export const dtCopy = {
  dt_s_page_title: "Rechercher des paquets typés",
  dt_s_title: "Rechercher des types",
  dt_s_subtitle:
    "Trouvez des paquets npm qui ont des déclarations de types, soit intégrés ou sur Definitely Typed.",
  dt_s_match: "résultat",
  dt_s_matchs: "résultats",
  dt_s_match_exact: "Résultat exact",
  dt_s_popular_on_dt: "Populaire sur Definitely Typed",
  dt_s_downloads_short: "DLs",
  dt_s_downloads_via: "Via",
  dt_s_module: "Module",
  dt_s_last_update: "Dernière mise à jour",
  dt_s_install: "Installer",
  dt_s_no_results: "Aucun résultat trouvé pour",
  dt_s_no_results_try: "Essayez une autre recherche ?",
  dt_s_copy: "copier",
  dt_s_copied: "copié",
};
